import React from 'react';

const DragNDropIndicationContext = React.createContext<boolean>(false);

export default DragNDropIndicationContext;
